/**
 * navBarカテゴリ並び順
 */
export default {
  state() {
    return {
      order: [],
      lastUpdateDate: null
    };
  },
  getters: {
    getOrder(state) {
      return state.order;
    },
    getLastUpdateDate(state){
      return state.lastUpdateDate;
    }
  },
  mutations: {
    setOrder(state, list) {
      state.order = list;
    },
    setLastUpdateDate(state, updateDate){
      state.lastUpdateDate = updateDate;
    }
  }
};
